"use strict";

const strf = require("./string.format.js");

const CartModel = require("./models/event.cart");
const CartItemModel = require("./models/event.cartitem");

/*
 *
 * Cart class for managing shopping cart
 *
 */

class MetaStreamIOCart {
  constructor({ constants, date, encryption, logger, storage, utility } = {}) {
    // Extend functionality with other MetaStream classes
    this.constant = constants;
    this.date = date;
    this.encryption = encryption;
    this.logger = logger;
    this.utility = utility;

    // Initialise variables
    this.reset();
  }

  reset() {
    this.cart = new CartModel();
    this.last_cart = {};
  }

  setCartId(id = null) {
    if (!id) {
      this.cart.id = this.utility.generateRandomId();
    } else {
      this.cart.id = id;
    }
    this.logger.log(
      "cart",
      this.constant.MetaStreamIO_Cart_CartIdSet.format(this.cart.id)
    );
  }

  // Add items to the cart - expects an array so this can be multiple items at once

  add(items = []) {
    try {
      for (let item in items) {
        let _new_item = new CartItemModel({
          price: items[item].price ? items[item].price : null,
          id: items[item].id ? items[item].id : null,
          name: items[item].name ? items[item].name : null,
          type: items[item].type ? items[item].type : null,
          validity: items[item].validity ? items[item].validity : null,
          value: items[item].value ? items[item].value : null,
          quantity: ((cart, item) => {
            let _id = item.id;
            try {
              return cart[_id].quantity + item.quantity;
            } catch (err) {
              return item.quantity;
            }
          })(this.cart.items, items[item]),
          recipients: items[item].recipients ? items[item].recipients : [],
        }).json();
        let _bid = items[item].id ? items[item].id : null;
        this.cart.items = { ...this.cart.items, [_bid]: _new_item };
        this.logger.log(
          "cart",
          this.constant.MetaStreamIO_Cart_AddedToCart.format(items[item].id)
        );
      }
    } catch (err) {
      this.logger.error(
        "cart",
        "addCartItem() error adding item to cart:",
        err
      );
    }
    this.logger.log(
      "cart",
      this.constant.MetaStreamIO_Cart_Cart.format(JSON.stringify(this.cart))
    );
    return this;
  }

  // Reduce the quantity of a specific item in the cart

  reduce(id = null, quantity = null) {
    let _quantity = quantity ? quantity : 1;
    if (this.cart.items[id]) {
      if (this.cart.items[id]["quantity"] > 0) {
        this.cart.items[id]["quantity"] =
          this.cart.items[id]["quantity"] - _quantity;
        this.logger.log(
          "cart",
          this.constant.MetaStreamIO_Cart_QuantityReduced.format(
            id,
            this.cart.items[id]["quantity"]
          )
        );
        this.logger.log(
          "cart",
          this.constant.MetaStreamIO_Cart_Cart.format(
            JSON.stringify(this.cart.items)
          )
        );
      } else {
        this.logger.log(
          "cart",
          this.constant.MetaStreamIO_Cart_QuantityZero.format(id)
        );
        this.logger.log(
          "cart",
          this.constant.MetaStreamIO_Cart_Cart.format(
            JSON.stringify(this.cart.items)
          )
        );
      }
    } else {
      this.logger.log(
        "cart",
        this.constant.MetaStreamIO_Cart_BundleNotInCart.format(id)
      );
      this.logger.log(
        "cart",
        this.constant.MetaStreamIO_Cart_Cart.format(
          JSON.stringify(this.cart.items)
        )
      );
    }
    return this;
  }

  delete(id = null) {
    if (this.cart.items[id]) {
      delete this.cart.items[id];
    } else {
      this.logger.log(
        "cart",
        this.constant.MetaStreamIO_Cart_BundleNotInCart.format(id)
      );
      this.logger.log(
        "cart",
        this.constant.MetaStreamIO_Cart_Cart.format(
          JSON.stringify(this.cart.items)
        )
      );
    }
    return this;
  }

  // Remove all items from the cart and generate a new cart id

  clear(cart_id = null) {
    try {
      this.cart = new CartModel({
        id: cart_id !== null ? cart_id : this.utility.generateRandomId(),
      });
      this.logger.log("cart", this.constant.MetaStreamIO_Cart_RemoveAllItems);
      this.logger.log(
        "cart",
        this.constant.MetaStreamIO_Cart_Cart.format(JSON.stringify(this.cart))
      );
    } catch (err) {
      return this;
    }

    return this;
  }

  get lastCart() {
    return this.last_cart;
  }

  set lastCart(input) {
    this.last_cart = input;
  }

  // Convert cart object to a list of objects with the bundle id as the key for each
  list(input = {}) {
    let _return = [];
    for (let id in input) {
      _return.push(input[id]);
    }
    return _return;
  }
}

module.exports = MetaStreamIOCart;
